import {useState, useEffect, useRef}        from "react";
import {useLoader}                          from "components/Covers/loadingCover";
import {useActionModal}                     from "components/Covers/confirmAction";
import {useInfoMsgModal}                    from "components/Covers/infoMessageModal";
import {useToastMessage}                    from "components/Covers/toastMessage";
import {InputGeneral}                       from "components/Field/field";
import {BtnCloseAction}                     from "components/Buttons/Close/BtnClose";
import MainStyle                            from "components/UI/main.module.scss";
// BEGIN AG AGRID
import {AgGridReact}                        from "ag-grid-react";
import {AllCommunityModule,ModuleRegistry}  from 'ag-grid-community';
import {AG_GRID_LOCALE_BR}                  from '@ag-grid-community/locale';

import {getFooterPhotosList,
        getFooterPhotoByID,
        updateFooterPhoto,
        deleteFooterPhoto}                 from "./imageFooterService";

import { imageToBase64, 
         q3x_FunData,
         getImgSrc,
         DefaultLoadingLogo,
         DavidCopperfield,
         Heimdall,
         GetLabel,
         GetAppLang,
         SetLastFeature }                  from "Utilities/utils";

import {DisplayGridDatetime}               from "components/Date/date";
import { useNavigate }                     from "react-router-dom";

let blank_file_obj = {
    'FILE_ID': 0,
    'TYPE_ID': 8,
    "STATUS_ID": 0,
    "FILE_DESC": "",
    "FILE_DATA": "",
    "FILE_B64": ""
};

let appLang = null; 

const FooterPhotoEditPanel = ({setProps, data}) => {
    const { showLoader, hideLoader }   = useLoader();               // Control over the loader
    const { showInfoMessage }          = useInfoMsgModal();         // Modal message control 
    const { showActionMessage }        = useActionModal();          // Modal message + action control     
    const { showToastMessage }         = useToastMessage();         // Toast message display
    const [fileObj,   setFileObj]      = useState(blank_file_obj);  // Sector Object
    const fileInputRef                 = useRef(null);
    
    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_file_obj });
    };

    const BtnExit = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 102)}<br/>{GetLabel(appLang, 103)}</> },
          { confirm_action: () => handleExit()}
        );
    };

    const handleSave = async () => {
        if (fileObj.FILE_ID > 0) {
            if (fileObj.FILE_DESC == "") {
                showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 145)});
                return;            
            }
            else if (fileObj.FILE_DATA == "" && fileObj.FILE_B64 == "") {
                showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 146)});
                return;            
            }
        }
        else {
            if (fileObj.FILE_DESC == "") {
                showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 145)});
                return;            
            }
            else if (fileObj.FILE_B64 == "") {
                showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 146)});
                return;            
            }
        }
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await updateFooterPhoto(fileObj);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
                if (fileObj.FILE_ID === 0) {
                    setProps({ setScreen: 1, data: blank_file_obj });
                }
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleDelete = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await deleteFooterPhoto(fileObj.FILE_ID, fileObj.TYPE_ID);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                setProps({ setScreen: 1, data: blank_file_obj });
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleChange = (updatedValues) => {
        setFileObj(prevState => ({
            ...prevState,
            ...updatedValues
        }));
    };

    const BtnUpload = async (event) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            try {
                const blob = URL.createObjectURL(file);
                const base64Image = await imageToBase64(blob);

                setFileObj((prevState) => ({
                    ...prevState,
                    FILE_B64: base64Image,
                  }));

                // Reset input 
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }

            } catch (error) {
                //console.error('Error converting to base64:', error);
            }
        }
    };

    const BtnRemove = () => {
        try {
            if (fileObj.FILE_ID > 0) {
                setFileObj((prevState) => ({
                    ...prevState,
                    FILE_DATA: "",
                    FILE_B64: ""
                  }));                
            }
            else {
                setFileObj((prevState) => ({
                    ...prevState,
                    FILE_B64: "",
                  }));
            }

        } catch (error) {
            //console.error('Error trying to remove the referenced file:', error);
        }
    };

    const BtnSave = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 147) },
          { confirm_action: () => handleSave()}
        );
    };

    const BtnDelete = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 148) },
          { confirm_action: () => handleDelete()}
        );
    };

    useEffect(() => {
        const fetchData = async (file_id) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getFooterPhotoByID(file_id, blank_file_obj.TYPE_ID);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;
                            fetchedData.FILE_B64 = "";
                            setFileObj(fetchedData || blank_file_obj);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }
            } 
            catch (error) {
                setFileObj(blank_file_obj);
            }
        };
        if (data?.FILE_ID && data.FILE_ID !== 0) {
            fetchData(data.FILE_ID);
        } 
        else {
            setFileObj(blank_file_obj);
        }
    }, [data]);
    
    const AnimatedSVG = () => {
        const [var0, setVar0] = useState(280);
        const [var1, setVar1] = useState(330);
        
        const direction0 = useRef(1); // 1 = up, -1 = down
        const direction1 = useRef(1);
        
        useEffect(() => {
          let frameId;
          const animate = () => {
            setVar0(prev => {
              let next = prev + direction0.current;
              if (next >= 330 || next <= 280) direction0.current *= -1;
              return next;
            });
      
            setVar1(prev => {
              let next = prev + direction1.current;
              if (next >= 380 || next <= 330) direction1.current *= -1;
              return next;
            });
      
            frameId = requestAnimationFrame(animate);
          };
      
          frameId = requestAnimationFrame(animate);
      
          return () => cancelAnimationFrame(frameId);
        }, []);
      
        return (
          <svg viewBox="0 0 800 400" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: 'auto' }}>
            <rect x="0" y="0" width="800" height="400" rx="15" fill="#f0f0f0" />
            <rect x="23" y="26" width="754" height="347" fill="#ffe0ab" />
            <rect x="23" y="26" width="754" height="110" fill="#87CEEB" />
            <circle cx="150" cy="80" r="50" fill="#FFE484" className={MainStyle.sun_logo_svg_image}/>
            <path className={MainStyle.cloud_logo_svg_image} d="M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"/>
            <path
              d="M23,135 C23 135, 777 135, 777 135 C777 135, 500 180, 580 180 C580 180, 700 200, 550 300 C550 300, 450 360, 300,371 L300 373, 23,373 Z"
              style={{ fill: '#30b1ce' }}
            />
            <path
              d={`
                M25,300
                C25 300,  400 ${var0}, 550 200
              `}
              style={{
                stroke: '#fff',
                strokeWidth: '3',
                fill: 'none',
              }}
            />
            <path
              d={`
                M25,350
                C25 350,  400 ${var1}, 580 225
              `}
              style={{
                stroke: '#fff',
                strokeWidth: '6',
                fill: 'none',
              }}
            />
          </svg>
        );
    };

    return(
        <>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={MainStyle.mt_3}/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_1}>                            
                    </div>
                    <div className={MainStyle.col_11}>
                        <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                            {<BtnCloseAction click_action={BtnExit}/>}
                        </div>
                    </div>
                </div>
                <div className={MainStyle.mt_3}/>


                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>
                    
                    <div className={MainStyle.mt_5}/>
                    <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                        <div className={MainStyle.col_lg_2}>
                                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                        <span className={[MainStyle.fs_6,
                                                          MainStyle.text_body,
                                                          MainStyle.fw_semibold
                                                        ].join(" ")}
                                        >
                                            {GetLabel(appLang, 149)} *:
                                        </span>
                                    </div>
                        </div>
                        <div className={MainStyle.col_lg_4}>
                            <div className={[MainStyle.align_items_center, MainStyle.mx_3].join(" ")}>
                                <InputGeneral 
                                                value={fileObj.FILE_DESC}
                                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                onChange={(event) => handleChange({ FILE_DESC: q3x_FunData(event.target.value) })}
                                                placeholder={GetLabel(appLang, 150)}
                                                maxLength={150}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{fileObj.FILE_DESC.length} {GetLabel(appLang, 44)} 150 {GetLabel(appLang, 45)}.</span>
                            </div>
                        </div>

                        <div className={MainStyle.col_lg_6}>
                        <div className={[ MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3,  MainStyle.mx_3].join(" ")}>
                                <p className={[  MainStyle.fs_8,
                                                    MainStyle.text_body_faded,
                                                    MainStyle.fw_semibold].join(" ")}
                                >
                                    {GetLabel(appLang, 151)}
                                    <br/>
                                    {GetLabel(appLang, 152)}
                                </p>
                            </div>
                            <div className={[MainStyle.mx_5].join(" ")}>
                                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.my_3].join(" ")}>                                        
                                        <div style={{overflowX: 'hidden', overflowY: 'hidden', width: '35rem'}}>
                                            {fileObj.FILE_ID != 0 ?
                                                fileObj.FILE_B64 != "" ?
                                                        <img src={`data:image/png;base64, ${fileObj.FILE_B64}`} style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}/>
                                                    :
                                                fileObj.FILE_DATA != "" ?
                                                        <img src={getImgSrc(fileObj.FILE_DATA)} style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}/>
                                                    :
                                                <AnimatedSVG/>

                                            :
                                                fileObj.FILE_B64 != "" ?
                                                    <img src={`data:image/png;base64, ${fileObj.FILE_B64}`} style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}/>
                                                :

                                                <AnimatedSVG/>
                                            }
                                        </div>
                                    </div>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg_1}></div>
                                        {
                                        fileObj.FILE_DATA != "" || fileObj.FILE_B64 != ""?
                                            <>
                                            <div className={MainStyle.col_lg_5}>
                                                <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3].join(" ")}>
                                                    <button
                                                        style={{width: '100%'}}
                                                        className={[MainStyle.btn_delete,                                                             MainStyle.rounded_3, 
                                                                    MainStyle.border, 
                                                                    MainStyle.shadow_sm, 
                                                                    MainStyle.fs_6,
                                                                    MainStyle.py_3,
                                                                    MainStyle.px_5,
                                                                    MainStyle.mx_3,
                                                                    MainStyle.rounded_3].join(" ")}
                                                        onClick={BtnRemove}
                                                    >
                                                        {GetLabel(appLang, 153)}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className={MainStyle.col_lg_5}>
                                                <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3].join(" ")}>
                                                    <label 
                                                        htmlFor="file-upload" 
                                                        style={{ display: 'inline-block', width: '100%', paddingTop: "0.77rem", paddingBottom: "0.77rem" }}
                                                        className={[MainStyle.text_center,
                                                                    MainStyle.btn_blue, 
                                                                    MainStyle.border, 
                                                                    MainStyle.shadow_sm, 
                                                                    MainStyle.fs_6,
                                                                    MainStyle.text_white,
                                                                    //MainStyle.py_3,
                                                                    MainStyle.px_5,
                                                                    MainStyle.mx_3,
                                                                    MainStyle.rounded_3].join(" ")} 
                                                    >
                                                        {GetLabel(appLang, 154)}
                                                    </label>
                                                    <input
                                                        id="file-upload"
                                                        type="file"
                                                        style={{ display: 'none'}}
                                                        ref={fileInputRef}
                                                        onChange={BtnUpload}
                                                    />
                                                </div>
                                            </div>
                                            </>
                                        :
                                            <>
                                            <div className={MainStyle.col_lg_10}>
                                                <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                                    <label 
                                                        htmlFor="file-upload" 
                                                        className={[MainStyle.btn_blue, 
                                                                    MainStyle.rounded_3, 
                                                                    MainStyle.border, 
                                                                    MainStyle.shadow_sm, 
                                                                    MainStyle.fs_6,
                                                                    MainStyle.text_white,
                                                                    MainStyle.py_3,
                                                                    MainStyle.px_5,
                                                                    MainStyle.mx_3].join(" ")} 
                                                    >
                                                        {GetLabel(appLang, 154)}
                                                    </label>
                                                    <input
                                                        id="file-upload"
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        ref={fileInputRef}
                                                        onChange={BtnUpload}
                                                    />
                                                </div>
                                            </div>
                                            </>
                                        }
                                        <div className={MainStyle.col_lg_1}></div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div className={[MainStyle.py_3, MainStyle.mx_5].join(" ")}/>
                    
                </div>

                <div className={MainStyle.my_5}/>

            </div>
            {/*--------------------------------------------------------------------------*/}            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_7}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(4,89,6) && (
                        fileObj.FILE_ID != 0 ? 
                            <div className={[MainStyle.mt_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete,                                                
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_5].join(" ")}
                                    onClick={BtnDelete}
                                >
                                    {GetLabel(appLang, 114)}
                                </button>
                            </div>
                    : 
                        null
                    )}
                </div>
                <div className={MainStyle.col_lg_1}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(4,89,4) && (
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_green, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_5].join(" ")}
                                onClick={BtnSave}
                            >
                                {GetLabel(appLang, 49)}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            {/*--------------------------------------------------------------------------*/}
        </>
    );

};

const FooterPhotoTableGrid = ({setProps}) => {
    const [ isLoading,  setIsLoading]            = useState(false);   // Loading fetch control
    const { showLoader, hideLoader }             = useLoader();       // Control over the  
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def
    const gridRef                                = useRef();
    const { showInfoMessage }                    = useInfoMsgModal(); // Modal message control 

    ModuleRegistry.registerModules([AllCommunityModule]);

    const filePreview = (params) => {
        return (        
            <>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                        <div className={[MainStyle.pt_3, MainStyle.pb_2].join(" ")}>
                            <img
                                style={{width: '5rem', height: '3rem'}} 
                                className={[MainStyle.border, MainStyle.shadow_sm].join(" ")} 
                                src={getImgSrc(params.value)}
                            />
                        </div>
                </div>
            </>
        );
    };

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true
    };

    const EditItem = (props) => {
        const handleData = () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_file_obj));
            obj_copy.FILE_ID = props.data.FILE_ID;
            setProps({ setScreen: 2, data: obj_copy });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };

    const defaultCol = [
        DavidCopperfield(4,89,4) && {
          headerName: GetLabel(appLang, 115),
          field: 'editar',
          cellRenderer: EditItem,
          cellClass: [MainStyle.table_text_center].join(" "), 
          headerClass: MainStyle.table_header_center,
          flex: 0,
        },
        { headerName: GetLabel(appLang, 34),   field: "FILE_ID"                ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" ")}    ,    
        { headerName: GetLabel(appLang, 36),   field: "FILE_DESC"              ,filter: true , flex: 1, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
        { headerName: GetLabel(appLang, 116),  field: "FILE_DATA"              ,autoHeight: true, flex: 0, cellRenderer: filePreview,}    ,
        { headerName: GetLabel(appLang, 117),  field: "CREATED"                ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
        { headerName: GetLabel(appLang, 118),  field: "UPDATED"                ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
    ].filter(Boolean);

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!isLoading) {
                setIsLoading(true);
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let data = await getFooterPhotosList();
                if (data) {
                    if (data?.status?.statusCode == 0) {
                        if (data?.response?.content) {
                            data = data.response.content;
                            setcolumnDefs(defaultCol);
                            let arr = [];
                            for(var j = 0; j < data.length; j++) {
                                arr.push(data[j]);
                            }
                            setRowData(arr);
                            hideLoader();
                            setIsLoading(false);
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                    }
                }
            }
        };
        fetchData();
    },[]);

    return (
        <>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: '40rem'}}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
    </>);
};

export const FooterPhotoPage = () => {
    const [ screenType, setScreenType ]       = useState(1);
    const [ defaultData, setDefaultData]      = useState({});
    const navigate                            = useNavigate();    

    const BtnNew = () => {
        handleChange({  setScreen: 2,
                        data: blank_file_obj });
    };

    const handleChange = ({ setScreen, data }) => {
        setDefaultData({ ...data });
        setScreenType(setScreen);
    };

    useEffect(() => {
        if (!Heimdall([4])) {
            navigate('/home');
        }
        else {
            SetLastFeature(4);
        }        
    }, [screenType, defaultData]);

    return (
        <>
        {
        screenType == 1? 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 155)}
                </p>
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_10}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(4,89,0) && (
                        <div className={[MainStyle.mx_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_blue, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_5].join(" ")}
                                onClick={BtnNew}
                            >
                                {GetLabel(appLang, 120)}
                            </button>
                        </div>
                    )}
                </div>
            </div>            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_12}>
                    <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                        <FooterPhotoTableGrid setProps={handleChange}/>
                    </div>
                </div>
            </div>
            <div className={MainStyle.pb_3}></div>
        </>
        : 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 155)}
                </p>
            </div>
            <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                <FooterPhotoEditPanel setProps={handleChange} data={defaultData} />
            </div>
        </>
        }
        </>
    );
};